/* Durable experiment exposure delivery. No dependency on the PostHog browser SDK. */
(function () {
  'use strict';
  const c=window.FTBStore;
  if (!c || c.qaTheme || window.FTBMeasurement) return;
  const endpoint=c.measurementEndpoint;
  if (!endpoint) return;
  const key='ftb:'+c.storeId+':measurement-outbox';
  const read=()=>{try {const v=JSON.parse(localStorage.getItem(key)||'[]');return Array.isArray(v)?v:[];} catch {return [];} };
  const save=v=>{try {localStorage.setItem(key,JSON.stringify(v));return true;} catch {return false;} };
  const same=(a,b)=>a.id===b.id && (a.stage||'')===(b.stage||'');
  const at=e=>Date.parse(e.occurredAt||e.exposedAt);
  let sending, retry, attempts=0;
  function enqueue(event) {
    if (!event || event.qa !== false || !event.id) return false;
    const pending=read().filter(e=>Date.now()-at(e)<86400000);
    if (!pending.some(e=>same(e,event)) && !save([...pending,event].slice(-100))) return false;
    void flush();return true;
  }
  function flush() {
    if (sending) return sending;
    sending=(async()=>{
      for (let delivered=0;delivered<100;delivered++) {
        const event=read()[0];if(!event)break;
        if (Date.now()-at(event)>=86400000) {save(read().filter(e=>!same(e,event)));continue;}
        try {
          const response=await fetch(endpoint+(event.stage?'/stage':''),{method:'POST',headers:{'Content-Type':'application/json'},
            body:JSON.stringify(event),credentials:'omit',keepalive:true,signal:AbortSignal.timeout(5000)});
          if (!response.ok) throw Error('Measurement pending');
          const receipt=await response.json();
          if (receipt.ok !== true || receipt.id !== event.id || (event.stage && receipt.stage!==event.stage)) throw Error('Invalid receipt');
          // Merge with current storage, preserving events added by another tab.
          save(read().filter(e=>!same(e,event)));
          const assignmentKey='ftb:'+c.storeId+':'+event.key;
          try {const assignment=JSON.parse(localStorage.getItem(assignmentKey));
            if (!event.stage && assignment?.id===event.id) localStorage.setItem(assignmentKey,JSON.stringify({...assignment,acknowledged:true}));
          } catch {}
          attempts=0;
        } catch {
          clearTimeout(retry);
          if (attempts<6) retry=setTimeout(()=>{sending=null;void flush();},Math.min(30000,1000*2**attempts++));
          break;
        }
      }
    })().finally(()=>{sending=null;});
    return sending;
  }
  window.FTBMeasurement={enqueue,flush};
  window.addEventListener('online',()=>{attempts=0;void flush();});
  window.addEventListener('pagehide',()=>{void flush();});
  document.addEventListener('visibilitychange',()=>{if(document.visibilityState==='visible') {attempts=0;void flush();}});
  document.dispatchEvent(new Event('ftb:measurement-ready'));
  void flush();
})();
